import { Box, styled } from '@mui/material';
import { LwButton } from 'redesign';
import { AddBlockButtonProps } from './add-block-button.types';

export const AddBlockButton = ({ onClick, disabled, label }: AddBlockButtonProps) => {
  return (
    <AddBlockButtonWrapper>
      <SeparatorWrapper>
        <Separator />
      </SeparatorWrapper>
      <LwButton iconColorMode="fill" onClick={onClick} disabled={disabled} style={{ width: '10%' }}>
        {label}
      </LwButton>
    </AddBlockButtonWrapper>
  );
};

const AddBlockButtonWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  gap: 1,
  mt: 1,
});

const SeparatorWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '10%',
  marginBottom: 8,
});

const Separator = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.lwPrimaryAccentLight[100]}`,
  height: '25px',
  width: '1%',
}));
